import { createBrowserRouter } from 'react-router-dom';
import ErrorPage from './ErrorPage';
import routes from 'base/constants/routes';
import RecommendationV2 from './RecommendationV2';
import { useLocation, Navigate } from 'react-router-dom';

function RequireSolId({ children }: { children: any } ) {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const solId = params.get('sol_id');

  if (!solId) {
    return <Navigate to="/404" />; // or return null;
  }

  return children;
}
const Router = createBrowserRouter([
  {
    path: '*',
    element: <ErrorPage />,
  },
  {
    path: '/',
    element: <RequireSolId><RecommendationV2 /></RequireSolId>,
  },
  {
    path: routes.error,
    element: <ErrorPage type="error" />,
  },
  {
    path: routes.recommendation,
    element: <RecommendationV2 />,
    errorElement: <ErrorPage type="error" isRecommendationPage={true}/>,
  }
]);

export default Router;
